module.exports = __webpack_public_path__ + "static/media/banner-mobile-shopping@3x.828ed33f.png";